import React from "react";
import ReactDOM from "react-dom";
import { ensureVersionPolling } from "./versionCheck";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TmsApp from "./apps/tms/src/App.js";
import AuditApp from "./apps/audit/src/App.js";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
// import SwitchAppButton from "./SwitchAppButton.js";

const hostname = window.location.hostname;

ensureVersionPolling(60000);

Sentry.init({
  //dsn: "https://17595309490979e34c4a059a1993bfd5@o4510062071644160.ingest.us.sentry.io/4510062077935616",
  dsn: "https://28f4a879e99ddd199d411653e4e4b7c3@o4510103103143936.ingest.de.sentry.io/4510753372242000",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    new RegExp(`^${window.location.origin.replace(/\./g, "\\.")}`),
  ],
});
let AppToRender;

if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
  function AppSelector() {
    // Check localStorage for previous selection on mount
    const [selected, setSelected] = React.useState(() => {
      return localStorage.getItem("aaj_selected_app") || null;
    });

    // When user selects an app, save to localStorage
    const handleSelect = (app) => {
      setSelected(app);
      localStorage.setItem("aaj_selected_app", app);
    };

    if (!selected) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            background: "linear-gradient(135deg, #e0e7ef 0%, #f5f7fa 100%)",
            fontFamily: "Roboto, Lato, Arial, sans-serif",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2.5rem 2.5rem 2.2rem 2.5rem",
              borderRadius: "1.5rem",
              boxShadow: "0 6px 32px 0 rgba(44,62,80,0.13)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "340px",
              maxWidth: "95vw",
              position: "relative",
            }}
          >
            {/* Logo image */}
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 24,
                boxShadow: "0 2px 10px rgba(33,147,176,0.12)",
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/logo192.png"}
                alt="AAJ Logo"
                style={{
                  width: 48,
                  height: 48,
                  objectFit: "contain",
                  borderRadius: "50%",
                }}
              />
            </div>
            <h2
              style={{
                marginBottom: 8,
                color: "#222f3e",
                fontWeight: 800,
                fontSize: "2.1rem",
                letterSpacing: "1px",
              }}
            >
              Welcome
            </h2>
            <div
              style={{
                marginBottom: 28,
                color: "#576574",
                fontSize: "1.1rem",
                textAlign: "center",
                maxWidth: 320,
              }}
            >
              Please select which application you want to launch
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "1.2rem",
              }}
            >
              <button
                onClick={() => handleSelect("tms")}
                style={{
                  padding: "1.1rem 2.5rem",
                  borderRadius: "1.5rem",
                  border: "none",
                  background:
                    "linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "1.18rem",
                  boxShadow: "0 2px 12px 0 rgba(33,147,176,0.10)",
                  cursor: "pointer",
                  transition: "transform 0.12s, box-shadow 0.12s",
                  marginBottom: 0,
                  letterSpacing: 0.5,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.045)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                🚚 TMS
              </button>
              <button
                onClick={() => handleSelect("audit")}
                style={{
                  padding: "1.1rem 2.5rem",
                  borderRadius: "1.5rem",
                  border: "none",
                  background:
                    "linear-gradient(90deg, #ee9ca7 0%, #ffdde1 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "1.18rem",
                  boxShadow: "0 2px 12px 0 rgba(238,156,167,0.10)",
                  cursor: "pointer",
                  transition: "transform 0.12s, box-shadow 0.12s",
                  letterSpacing: 0.5,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.045)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                🧾 Audit
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (selected === "tms") return <TmsApp />;
    if (selected === "audit") return <AuditApp />;
    return null;
  }
  AppToRender = AppSelector;
} else if (hostname.includes("dev.aajswift.com")) {
  AppToRender = TmsApp;
}
// else if (hostname === 'app.aajswift.com') {
//   AppToRender = TmsApp;
// }
else if (hostname === "optimise.aajscm.com") {
  AppToRender = AuditApp;
} else {
  AppToRender = TmsApp;
}

ReactDOM.render(
  <>
    <ToastContainer
      position="bottom-right"
      newestOnTop
      closeOnClick
      theme="light"
    />
    <AppToRender />
  </>,
  document.getElementById("root"),
);
